<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Search Location Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5">
      {{ siteText.ui.searchLocationPageHeader }}
    </h2>
    <v-card>
      <v-card-text class="centerContainer">
        <div>
          <p><span><strong> {{ siteText.ui.serviceSelectedService }} </strong></span>{{ selectedService1.Name }}
             <span v-if="displaySelectedService2">, {{ selectedService2.Name }} </span>
          </p>
          <!-- <p> {{ selectedService1.AdditionalInfoText }} 
            <a
              target="_blank"
              :href='selectedService1.Url'
            >{{ selectedService1.UrlText }}</a>
          </p> -->
        </div>
        <!-- <div v-if="displaySelectedService2">
          <p>{{ selectedService2.Name }}</p>
          <p> {{ selectedService2.AdditionalInfoText }} 
            <a
              target="_blank"
              :href='selectedService2.Url'
            >{{ selectedService2.UrlText }}</a>
          </p>
        </div> -->
        <p><strong> {{ siteText.ui.searchLocationLabel }}  </strong></p>
        <p> {{ siteText.ui.searchLocationInfoText }}  </p>
        <p v-html="siteText.ui.searchLocationInstruction"></p>
        <v-combobox
           :label="siteText.ui.searchLocationCityLabel"
           clearable
           filled
           dense
           :items="cityList"
           :search-input.sync="citySearch"
           item-text="Name"
           item-value="Name"
           v-model="cityName"
        ></v-combobox>
        <p><strong> {{ siteText.ui.searchLocationOrText }}  </strong></p>
        <v-text-field
           :label="siteText.ui.searchLocationZipCodeLabel"
           clearable
           v-model="zipCode"
           mask="#####"
           placeholder="#####"
           maxlength="5"
           inputmode="numeric"
           @keypress="isNumber"
           filled
           dense
        ></v-text-field>
        <p>
          <a
            href="#"
            class="text-decoration-underline" 
            @click="seeAllLocations()">
              {{ siteText.ui.searchLocationSeeAll }}
          </a>
        </p>
        <p></p>
        <!-- <p> {{ siteText.ui.searchLocationSeeAllText }} </p> -->
        <span class="red--text" style="font-size:14px" v-if="errorMessage">{{ errorMessage }}</span>
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-left pt-md-4">
      <!-- Desktop Layout -->
    <v-layout row wrap class="hidden-sm-and-down">
    <v-flex md3>
    <v-btn
      class="ma-2 dmv-btn"
      height="45px"
      width="260px"
      @click="back()"
    ><v-icon>mdi-arrow-left</v-icon>
      {{ siteText.ui.searchLocationBack }}
    </v-btn>
    </v-flex>
    <v-flex md3>
    <v-btn
      class="ma-2 dmv-btn"
      height="45px"
      width="260px"
      @click="searchLocationSubmit()"
    >
        {{ siteText.ui.searchLocationSubmit }}
      <v-icon>mdi-arrow-right</v-icon>
    </v-btn>
    </v-flex>
    </v-layout>
     <!-- Mobile Layout -->
     <v-layout row wrap class="hidden-md-and-up">
      <v-flex xs12>
        <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        @click="searchLocationSubmit()"
      >
          {{ siteText.ui.searchLocationSubmit }}
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        @click="back()"
      ><v-icon>mdi-arrow-left</v-icon>
        {{ siteText.ui.searchLocationBack }}
      </v-btn>
      </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SearchLocationPage',
  data: () => ({
    cityName: '',
    zipCode: '',
    errorMessage:'',
    citySearch: null,
  }),
  methods: {
    ...mapActions({
      navToSelectAllLocationsPageAction: 'navToSelectAllLocationsPage'
    }),
    ...mapActions(['getAvailableLocations']),
    ...mapActions({setCity:'city'}),
    ...mapActions({setZip: 'zip'}),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      const backPage = !this.reschedule ? 'SelectServicePage' : 'RescheduleReservationPage';
      const pageName = !this.reschedule ? 'Select Service for Reservation' : 'Current Reservation';
      this.$emit('navigateTo', backPage, { 
          pageName:pageName
        });
    },
    async searchLocationSubmit() {
      this.errorMessage = '';
      console.log(this.cityName, this.zipCode, this.serviceTypeForLookUp);
      const cityName = this.cityName ? this.cityName.Name : '';
      if(!this.cityName && !this.zipCode) {
        this.errorMessage = this.siteText.errors.provideCityOrZip;
        return;
      }
      
      const serviceTypeId = this.selectedService1.TypeId;
      const serviceTypeId2 = this.selectedService2.TypeId;

      const success = await this.getAvailableLocations({city: cityName, zip: this.zipCode, serviceTypeId: serviceTypeId, serviceTypeId2: serviceTypeId2});
      if(success)
      {
        this.setCity(cityName);
        this.setZip(this.zipCode);
        
        this.$emit('navigateTo', 'SelectLocationPage', { 
          pageName:'Select Reservation Location'
        });
      } else {
        const searchValue = !this.cityName || this.cityName == '' ? this.zipCode : this.cityName.Name;
        this.errorMessage = this.siteText.errors.noAvailabilitySearchLocations.replace("CITY_ZIP", searchValue);
      }

    },
    seeAllLocations() {
      this.navToSelectAllLocationsPageAction({ value: 'SearchLocationPage' });
      this.$emit('navigateTo', 'SelectAllLocationsPage', { 
          pageName:'Select Reservation Location'
        });
    },
    isNumber(e) {
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        // Number
        return true;
      }
      return e.preventDefault();
    },
  },
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['cities']),
    ...mapGetters('selectedService', [
      'numberOfServices',
      'selectedService1',
      'selectedService2',
      'serviceTypeForLookUp'
    ]),
    ...mapGetters(['reschedule','city','zip']),
    displaySelectedService2() {
      if (this.numberOfServices === 2) {
          return true;
      }
      return false;
    },
    cityList() {
      let citySearch = this.citySearch ? this.citySearch.replace(" ", "") : null;
      return !citySearch || citySearch === "" ? null : this.cities;
    }
  },
  mounted() {
    this.zipCode = this.zip;
    if(this.city) {
      this.cityName = this.cities.find(element=>element.Name === this.city);
    }    
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
